import styled from 'styled-components'
import { Theme, PageMain } from 'styles/index'

export const Container = styled(PageMain)`
  padding-top: 0px;
  padding: 0;
  .table-conteiner {
    max-width: calc(100% - 24px);
    max-height: 100%;
    width: fit-content;
    overflow: auto;
  }
  .table-conteiner::-webkit-scrollbar {
    background: white;
    border: 0;
    width: 8px; /* Largura da barra de rolagem vertical */
    height: 8px; /* Altura da barra de rolagem horizontal */
  }
  .table-conteiner::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 50px;
  }

  .grid-action {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    height: 72px;
    gap: 16px;
  }
  .grid-action-btn {
    cursor: pointer;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .ok-txt {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
  }

  .profile-card {
    font-family: 'Inter';
    color: #1c1d22;
    gap: 8px;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    display: flex;
    align-items: center;
    .picture {
      width: 26.78px;
      height: 26.78px;
      border-radius: 5px;
      object-fit: cover;
    }
  }
  .colaboradores-subtitle {
    margin-bottom: 20px;
    height: 17px;
    color: #868686;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: 0.14px;
  }
  .colaboradores-title {
    height: 23px;
    margin-bottom: 30px;
    color: #000;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .colaboradores-cards-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    gap: 24px;
  }
  .colaboradores-container-content {
    display: flex;
    flex-direction: column;
    height: auto;
  }
  .colaboradores-container-filter {
    display: flex;
    gap: 24px;
  }
  .grid-input {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    border: 1px solid transparent;
    background-color: transparent;
    color: ${Theme.pallete.PRIMARY};
    max-width: 100%;
    width: 100%;
    height: 40px;
    white-space: nowrap;
    padding: 8px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 5px;
    outline: none;
    transition: all 0.3s ease-out;
  }
  .grid-input:focus {
    border: 1px solid #1c1d22;
  }
  .tooltip {
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
  }
  .grid-text {
    color: ${Theme.pallete.PRIMARY};
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    border: 1px solid transparent;
    padding-left: 8px;
    padding-right: 8px;
    text-align: left;
    height: 40px;
    white-space: nowrap;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    line-height: 40px; /* Centraliza o texto verticalmente */
  }
  .grid-item {
    max-width: 100%;
    width: 100%;
  }
  .empty-field {
    align-self: 'center';
    color: '#757575';
    padding-left: 8px;
    opacity: 0.5;
  }
`
